import actionTypes from './actionTypes';

const INIT_STATE = {
  getCitiesListLoading: false,
  getCitiesListFailed: false,
  getCitiesListError: false,
  getCitiesListMessage: '',
  citiesList: [],
  citiesListTotalRecords: 0,

  getCityByIdLoading: false,
  getCityByIdFailed: false,
  getCityByIdError: false,
  getCityByIdMessage: '',
  city: [],

  updateCityLoading: false,
  updateCityFailed: false,
  updateCityError: false,
  updateCityMessage: '',

  addNewCityLoading: false,
  addNewCityFailed: false,
  addNewCityError: false,
  addNewCityMessage: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_CITIES_LIST_LOADING: {
      return {
        ...state,
        getCitiesListLoading: true,
        getCitiesListFailed: false,
        getCitiesListError: false,
        getCitiesListMessage: '',
        citiesList: [],
        citiesListTotalRecords: 0,
      };
    }
    case actionTypes.GET_CITIES_LIST_SUCCESS: {
      return {
        ...state,
        getCitiesListLoading: false,
        getCitiesListFailed: false,
        getCitiesListError: false,
        getCitiesListMessage: '',
        citiesList: action.payload.mappedCities,
        citiesListTotalRecords: action.payload.totalRecords,

      };
    }
    case actionTypes.GET_CITIES_LIST_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCitiesListLoading: false,
        getCitiesListFailed: true,
        getCitiesListError: false,
        getCitiesListMessage: message,
        citiesList: [],
        citiesListTotalRecords: 0,
      };
    }
    case actionTypes.GET_CITIES_LIST_REJECT: {
      return {
        ...state,
        getCitiesListLoading: false,
        getCitiesListFailed: false,
        getCitiesListError: true,
        getCitiesListMessage: '',
        citiesList: [],
        citiesListTotalRecords: 0,
      };
    }

    case actionTypes.GET_CITY_BY_ID_LOADING: {
      return {
        ...state,
        getCityByIdLoading: true,
        getCityByIdFailed: false,
        getCityByIdError: false,
        getCityByIdMessage: '',
        city: [],
      };
    }
    case actionTypes.GET_CITY_BY_ID_SUCCESS: {
      return {
        ...state,
        getCityByIdLoading: false,
        getCityByIdFailed: false,
        getCityByIdError: false,
        getCityByIdMessage: '',
        city: action.payload,
      };
    }
    case actionTypes.GET_CITY_BY_ID_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        getCityByIdLoading: false,
        getCityByIdFailed: true,
        getCityByIdError: false,
        getCityByIdMessage: message,
        city: [],
      };
    }
    case actionTypes.GET_CITY_BY_ID_REJECT: {
      return {
        ...state,
        getCityByIdLoading: false,
        getCityByIdFailed: false,
        getCityByIdError: true,
        getCityByIdMessage: '',
        city: [],
      };
    }

    case actionTypes.UPDATE_CITY_LOADING: {
      return {
        ...state,
        updateCityLoading: true,
        updateCityFailed: false,
        updateCityError: false,
        updateCityMessage: '',
      };
    }
    case actionTypes.UPDATE_CITY_SUCCESS: {
      return {
        ...state,
        updateCityLoading: false,
        updateCityFailed: false,
        updateCityError: false,
        updateCityMessage: '',
      };
    }
    case actionTypes.UPDATE_CITY_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        updateCityLoading: false,
        updateCityFailed: true,
        updateCityError: false,
        updateCityMessage: message,
      };
    }
    case actionTypes.UPDATE_CITY_REJECT: {
      return {
        ...state,
        updateCityLoading: false,
        updateCityFailed: false,
        updateCityError: true,
        updateCityMessage: '',
      };
    }

    case actionTypes.ADD_NEW_CITY_LOADING: {
      return {
        ...state,
        addNewCityLoading: true,
        addNewCityFailed: false,
        addNewCityError: false,
        addNewCityMessage: '',
      };
    }
    case actionTypes.ADD_NEW_CITY_SUCCESS: {
      return {
        ...state,
        addNewCityLoading: false,
        addNewCityFailed: false,
        addNewCityError: false,
        addNewCityMessage: '',
      };
    }
    case actionTypes.ADD_NEW_CITY_FAILED: {
      const { message } = action.payload;
      return {
        ...state,
        addNewCityLoading: false,
        addNewCityFailed: true,
        addNewCityError: false,
        addNewCityMessage: message,
      };
    }
    case actionTypes.ADD_NEW_CITY_REJECT: {
      return {
        ...state,
        addNewCityLoading: false,
        addNewCityFailed: false,
        addNewCityError: true,
        addNewCityMessage: '',
      };
    }
    
    default: {
      return { ...state };
    }
  }
};